import useFetchDoubts from "./hooks/useFetchDoubts";
import { Caption, Container, TopCaptionsContainer } from "./styles";
import DoubsTable from "./tables/DoubtsTable";

export default function DuvidasV3() {
  const { data, isLoading, page, filters, onChangePage, onResetFilters, onSubmitFilters } = useFetchDoubts();

  return (
    <Container>
      <TopCaptionsContainer>
        <Caption>*A IA para de responder após 2 respostas, podendo ser reativada novamente</Caption>
        <Caption>**A IA possui um limite de 20 respostas automáticas, não podendo ser ativada após esse limite</Caption>
      </TopCaptionsContainer>
      <DoubsTable
        data={data?.data || []}
        paging={data?.paging || {}}
        isLoading={isLoading}
        page={page}
        selectedFilters={filters}
        onChangePage={onChangePage}
        onResetFilters={onResetFilters}
        onSubmitFilters={onSubmitFilters}
      />
    </Container>
  );
}
